import Grid from '@jobcost-monorepo/crud/ui/Grid';
import {
  IListActivityFetchParams,
  IActivity,
  MN_ACTIVITIES,
} from '@jobcost-monorepo/crud';

export default function ActivitiesPage() {
  return (
    <Grid<IActivity, IListActivityFetchParams>
      moduleName={MN_ACTIVITIES}
      updateStore={false}
    ></Grid>
  );
}
